export default "__VITE_ASSET__IiOWKEG9__"